/**
 * @generated SignedSource<<b6c63a9b88c1e1e736a7b4770adc04cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobSkillsFields_SkillsFragment$data = {
  readonly skills?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly industries: ReadonlyArray<{
          readonly rawId: number | null | undefined;
        }> | null | undefined;
        readonly name: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "JobSkillsFields_SkillsFragment";
};
export type JobSkillsFields_SkillsFragment$key = {
  readonly " $data"?: JobSkillsFields_SkillsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobSkillsFields_SkillsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "editable"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": require('./JobSkillsField_SkillsQuery.graphql')
    }
  },
  "name": "JobSkillsFields_SkillsFragment",
  "selections": [
    {
      "condition": "editable",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1000
            }
          ],
          "concreteType": "SkillConnection",
          "kind": "LinkedField",
          "name": "skills",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SkillEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Skill",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Industry",
                      "kind": "LinkedField",
                      "name": "industries",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "rawId",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "skills(first:1000)"
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "fb93578a9a3b704720e3ca5a5faa3fd1";

export default node;
